import { MediaImage } from '@app/v2/auth/types/media.type'
import { INVITATION_STATUS } from '@app/v2/settings/enums/invitation-status.enum'

// TODO: Refactor user type
export type UserInfo = {
  role?: string
  status?: string
}

export enum USER_ROLES {
  OWNER = 'owner',
  ADMIN = 'admin',
  COLLABORATOR = 'collaborator',
  VIEWER = 'viewer',
  APPROVER = 'approver',
  ACCOUNTANT = 'accountant'
}

export type User = {
  id: number
  name: string
  email: string
  pictures: any[]
  full_name: string | null
  role: USER_ROLES
  //   status: INVITATION_STATUS;
  seen_at: string
  avatar: MediaImage | null
  suggest_mfa?: boolean
  mfa_enabled?: boolean
  is_admin?: boolean
  confirmed?: boolean
  phone_number?: string
}

export type Roles = {
  id: number
  name: string
}

export type Crew = Partial<Pick<User, 'id' | 'full_name' | 'avatar'>> & {
  base_rate_per_day: number
  number_of_entries: number
  avg_rating: number
  avg_punctuality: number
  avg_grooming: number
  avg_team_work: number
  avg_cheerfulness: number
  avg_soft_skills: number
  avg_data_quality: number
  events_count: number
}

export type CrewProfileResponse = { data: { crew: Crew }; message: string }

export type OrganizationUser = {
  id: number
  user_id: number
  fullname: string
  email: string
  role: USER_ROLES
  status: INVITATION_STATUS
  last_seen: string
  profile_picture: string
}

export type FullnameParts = {
  salutations: string | null
  firstName: string | null
  middleName: string | null
  lastName: string | null
}

export type InviteTeamMemberPayload = {
  email: string
  role: USER_ROLES
  message: string
  fullname: FullnameParts
}
